@if (loading) {
  <div class="page-loading">
    <span>
      <span></span>
    </span>
  </div>
}
@if (category) {
  <pc-bambuser-playlist />
  <div class="grid-layout {{ category.slug }}" data-infinite-scroll="$ctrl.nextPage()" data-infinite-scroll-distance="0"
    >
    <div class="category-image-header row clearfix max-width">
      @if (category.banner_image_name) {
        <div class="image">
          <img alt="{{ category.title }}" [src]="bannerImageUrl" />
        </div>
      }
      <div class="title">
        <h1>
          @if (category.font_icon) {
            <span class="fa fa-fw" [ngClass]="category.font_icon"></span>
          }
          {{ category.title }}
        </h1>
      </div>
      <div class="description" [innerHTML]="category.description"></div>
      <div class="center-buttons">
        <label>
          <input type="checkbox" [checked]="sortAZChecked" (change)="onSortAZChange($event.target.checked)" />
          <span>A-Z</span>
        </label>
        <label>
          <input type="checkbox" [checked]="sortZAChecked" (change)="onSortZAChange($event.target.checked)" />
          <span>Z-A</span>
        </label>
        <label>
          <input type="checkbox" [checked]="sortRecentChecked" (change)="onSortRecentChange($event.target.checked)" />
          <span>Recently Added</span>
        </label>
      </div>
    </div>
    <product-list class="{{category.slug}}" [items]="category.products"></product-list>
  </div>
}
